var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 126,
    viewBox: "0 0 125 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.094 0.871094C27.8583 0.871094 0 28.7294 0 62.9651C0 97.2008 27.8583 125.059 62.094 125.059C96.3297 125.059 124.188 97.2008 124.188 62.9651C124.188 28.7294 96.3382 0.871094 62.094 0.871094ZM62.2997 1.28254C96.0725 1.39397 123.537 28.7894 123.768 62.5365L104.713 62.6051C104.516 39.3327 85.5892 20.449 62.2997 20.3376V1.28254ZM62.2997 63.1708L82.4434 63.1022C82.3748 74.1941 73.383 83.2031 62.2997 83.3145V63.1708ZM62.2997 83.7259C73.6145 83.6145 82.7863 74.417 82.8548 63.1022L104.31 63.0251C104.284 86.2118 85.4607 105.078 62.2997 105.19V83.7259ZM62.2997 20.7491C85.3664 20.8605 104.113 39.5555 104.301 62.6051L82.8463 62.6822C82.7006 51.436 73.563 42.3157 62.2997 42.2128V20.7491ZM82.4348 62.6822L62.2997 62.7508V42.6157C73.3402 42.7271 82.2891 51.6589 82.4348 62.6822ZM19.878 62.9136C19.9037 39.727 38.7273 20.8605 61.8883 20.7491V42.2042C50.5735 42.3157 41.4017 51.5132 41.3331 62.8279L19.878 62.9136ZM61.8883 42.6157V62.7594L41.7446 62.8279C41.8217 51.736 50.805 42.7357 61.8883 42.6157ZM61.8883 1.28254V20.3376C38.4959 20.449 19.4922 39.4955 19.4665 62.9136L0.411446 62.9822C0.411446 62.9736 0.411446 62.9736 0.411446 62.9651C0.411446 29.0208 27.9697 1.39397 61.8883 1.28254ZM61.8883 124.648C28.1154 124.536 0.651455 97.1408 0.420017 63.3937L19.4751 63.3251C19.6722 86.5975 38.5987 105.481 61.8883 105.593V124.648ZM61.8883 105.181C38.8216 105.07 20.0751 86.3746 19.8865 63.3251L41.3417 63.2479C41.496 74.5027 50.6249 83.6145 61.8883 83.7259V105.181ZM41.7531 63.2479L61.8883 63.1794V83.3145C50.8564 83.2031 41.9074 74.2713 41.7531 63.2479ZM62.2997 124.648V105.593C85.6921 105.481 104.696 86.4346 104.721 63.0165L123.777 62.9479C123.777 62.9565 123.777 62.9565 123.777 62.9651C123.785 96.9093 96.2182 124.536 62.2997 124.648Z",
    fill: "#01F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6427 1.07617H61.6826V7.04213H62.6427V1.07617Z",
    fill: "#01F4F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6417 118.791H61.6816V124.757H62.6417V118.791Z",
    fill: "#01F4F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.716 23.6614L109.038 22.9824L104.818 27.201L105.497 27.8799L109.716 23.6614Z",
    fill: "#01F4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8507 106.519L26.1719 105.84L21.9533 110.058L22.6322 110.737L26.8507 106.519Z",
    fill: "#01F4F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0901 105.839L97.4111 106.518L101.629 110.737L102.308 110.058L98.0901 105.839Z",
    fill: "#01F4F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1203 22.868L14.4414 23.5469L18.6599 27.7654L19.3388 27.0866L15.1203 22.868Z",
    fill: "#01F4F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5483 15.834V23.4046",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1934 17.457L52.1513 24.7697",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6733 22.2207L42.4526 28.79",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7778 29.8066L34.1356 35.1774",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.189 39.6992L27.7457 43.4921",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4087 51.2129L23.7395 53.17",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 63.5781H22.3579",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4087 75.9298L23.7395 73.9727",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.189 87.4452L27.7457 83.6523",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7778 97.3341L34.1356 91.9785",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6733 104.923L42.4526 98.3535",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1934 109.688L52.1513 102.375",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5483 111.309V103.738",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9027 109.688L72.9448 102.375",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4228 104.923L82.6436 98.3535",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 97.3341L90.9604 91.9785",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.907 87.4452L97.3501 83.6523",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.688 75.9298L101.357 73.9727",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.312 63.5781H102.723",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.688 51.2129L101.357 53.17",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.907 39.6992L97.3501 43.4921",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3182 29.8066L90.9604 35.1774",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4228 22.2207L82.6436 28.79",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9027 17.457L72.9448 24.7697",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6323 7.68359L59.0118 12.9633",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7485 8.09375L55.4922 13.3279",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8926 8.77539L52.0006 13.9337",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0986 9.7168L48.5557 14.7993",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3789 10.9297L45.1851 15.8908",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.752 12.3887L41.9072 17.2132",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.23 14.0996L38.7191 18.7724",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8462 16.0566L35.6541 20.5474",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6138 18.2422L32.71 22.5206",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5171 20.6543L29.9169 24.7051",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6177 23.2637L27.2907 27.0717",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9004 26.084L24.8314 29.619",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3813 29.0742L22.5552 32.3361",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 32.2461L20.461 35.2045",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0107 35.5547L18.5944 38.1945",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1748 39.0117L16.9254 41.333",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5806 42.5801L15.483 44.5675",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24414 46.2656L14.268 47.889",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 50.0117L13.298 51.3013",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34766 53.8359L12.5688 54.7614",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81641 57.7207L12.0679 58.2669",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54395 61.6191L11.8258 61.8012",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54395 65.5199L11.8258 65.3379",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81641 69.4324L12.0679 68.8711",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34766 73.3005L12.5688 72.375",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 77.1221L13.298 75.8477",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24414 80.8866L14.268 79.248",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5806 84.5597L15.483 82.5723",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1748 88.1244L16.9254 85.8184",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0107 91.5852L18.5944 88.9453",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 94.8925L20.461 91.9492",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3813 98.0592L22.5552 94.8125",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9004 101.049L24.8314 97.5137",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6177 103.873L27.2907 100.064",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5171 106.48L29.9169 102.43",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6138 108.894L32.71 104.615",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8462 111.077L35.6541 106.602",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M36.23 113.036L38.7191 108.363",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39.752 114.75L41.9072 109.926",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3789 116.22L45.1851 111.244",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0986 117.418L48.5557 112.336",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8926 118.358L52.0006 113.199",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7485 119.043L55.4922 113.809",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6323 119.454L59.0118 114.189",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5498 119.59V114.311",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4649 119.454L66.0854 114.189",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3506 119.043L69.6069 113.809",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2056 118.358L73.0977 113.199",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M78 117.418L76.543 112.336",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7187 116.22L79.9126 111.244",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3462 114.75L83.1909 109.926",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8671 113.036L86.3779 108.363",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2517 111.077L89.4438 106.602",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4844 108.894L92.3882 104.615",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5805 106.48L95.1807 102.43",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5498 7.54688V12.8266",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M101.48 103.871L97.8071 100.062",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M104.196 101.049L100.265 97.5137",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M106.716 98.0612L102.542 94.8145",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M109.007 94.8925L104.621 91.9492",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M111.087 91.5832L106.503 88.9434",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M112.923 88.1225L108.173 85.8164",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M114.517 84.5597L109.615 82.5723",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M115.853 80.8866L110.829 79.248",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M116.93 77.1221L111.8 75.8477",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 73.3005L112.528 72.375",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M118.281 69.4305L113.03 68.8691",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M118.553 65.516L113.271 65.334",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M118.553 61.6191L113.271 61.8012",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M118.281 57.7207L113.03 58.2669",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 53.834L112.528 54.7594",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M116.93 50.0137L111.8 51.3033",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M115.853 46.2656L110.829 47.889",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M114.517 42.5801L109.615 44.5675",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M112.923 39.0117L108.173 41.333",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M111.087 35.5547L106.503 38.1945",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M109.007 32.2461L104.621 35.2045",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M106.716 29.0742L102.542 32.3361",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M104.196 26.0879L100.265 29.6229",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M101.48 23.2637L97.8071 27.0717",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5805 20.6543L95.1807 24.7051",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4844 18.2422L92.3882 22.5206",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2512 16.0586L89.4434 20.5494",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8666 14.0996L86.3774 18.7724",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3452 12.3887L83.1899 17.2132",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7178 10.9297L79.9116 15.8908",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9995 9.7168L76.5425 14.7993",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2047 8.77539L73.0967 13.9337",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3506 8.0918L69.6069 13.326",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4639 7.68164L66.0845 12.9613",
    stroke: "#01F4F6",
    strokeWidth: 0.3516,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M109.716 23.6614L109.038 22.9824L104.818 27.201L105.497 27.8799L109.716 23.6614Z",
    fill: "#01F4F6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8507 106.519L26.1719 105.84L21.9533 110.058L22.6322 110.737L26.8507 106.519Z",
    fill: "#01F4F6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0901 105.839L97.4111 106.518L101.629 110.737L102.308 110.058L98.0901 105.839Z",
    fill: "#01F4F6"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1203 22.868L14.4414 23.5469L18.6599 27.7654L19.3388 27.0866L15.1203 22.868Z",
    fill: "#01F4F6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.577 75.7237L92.8312 89.9516C93.331 90.4472 93.612 91.1219 93.612 91.8257C93.612 92.5296 93.331 93.2043 92.8312 93.6999C92.3356 94.1996 91.6609 94.4807 90.9571 94.4807C90.2532 94.4807 89.5785 94.1996 89.0829 93.6999L74.855 79.4456C71.166 82.3413 66.6104 83.9125 61.9206 83.9067C50.2578 83.9067 40.8032 74.4521 40.8032 62.7893C40.8032 51.1265 50.2578 41.6719 61.9206 41.6719C73.5835 41.6719 83.038 51.1265 83.038 62.7893C83.0439 67.4791 81.4727 72.0346 78.577 75.7237ZM61.9206 46.9512C53.1735 46.9512 46.0826 54.0422 46.0826 62.7893C46.0826 71.5364 53.1735 78.6273 61.9206 78.6273C70.6677 78.6273 77.7587 71.5364 77.7587 62.7893C77.7587 54.0422 70.6677 46.9512 61.9206 46.9512Z",
    fill: "#03A8A8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.d35ec49ac9a324287e2d2dc4fe0ad5a2.svg";
export { ForwardRef as ReactComponent };